import React from 'react';
import { ServicesSection } from '../components/ServicesSection';
import { CTABanner } from '../components/CTABanner';
export function ServicesPage() {
  return <main data-id="element-416">
      {/* Hero Banner */}
      <section className="relative bg-slate-900 py-24 text-center px-4 overflow-hidden" data-id="element-417">
        <div className="absolute inset-0 z-0" data-id="element-418">
          <img src="https://images.unsplash.com/photo-1616432043562-3671ea2e5242?w=1600" alt="Parcels and packages" className="w-full h-full object-cover" data-id="element-419" />
          <div className="absolute inset-0 bg-slate-900/80 mix-blend-multiply" data-id="element-420" />
        </div>
        <div className="container mx-auto max-w-3xl relative z-10" data-id="element-421">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-422">
            Our Services
          </h1>
          <p className="text-xl text-slate-300" data-id="element-423">
            Professional courier drivers for hire and comprehensive delivery
            solutions for businesses and individuals across the UK.
          </p>
        </div>
      </section>

      <ServicesSection data-id="element-424" />

      {/* Additional Details */}
      <section className="py-20 bg-slate-50" data-id="element-425">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-426">
          <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-8 md:p-12" data-id="element-427">
            <h2 className="text-2xl font-bold text-slate-900 mb-6" data-id="element-428">
              Why Our Services Stand Out
            </h2>
            <div className="space-y-6 text-slate-600" data-id="element-429">
              <p data-id="element-430">
                At Universal Global Logistics, we primarily supply professional
                courier drivers that you can hire for any job. Whether you need
                a driver for a single emergency delivery or a team of drivers on
                a long-term contract, we have the people and resources to
                support you.
              </p>
              <p data-id="element-431">
                All our drivers are experienced, vetted, and insured. They come
                equipped to handle items of all sizes, and are trained to ensure
                the utmost care is taken with your goods. We also offer a full
                item and parcel delivery service for when you need us to handle
                the entire job.
              </p>
              <p data-id="element-432">
                By choosing us, you're partnering with the UK's leading
                emergency courier provider — flexible, reliable, and always
                ready.
              </p>
            </div>
          </div>
        </div>
      </section>

      <CTABanner data-id="element-433" />
    </main>;
}